// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Merriweather', 'Merriweather Fallback'","fontStyle":"normal"},"className":"__className_1836d9"};